import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// import { ModalComponent } from '../../../shared/components/modal/modal.component';
// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { LoginComponent } from '@shared/components/login/login.component';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';
declare var ga: any;

@Component({
  selector: 'app-access-account-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent,LoginComponent, LanguageSelectorComponent],
  templateUrl: './access-account-section.component.html',
  styleUrls: ['./access-account-section.component.scss'],
  providers: [LoginService, ErrorHandler, DataStorageService]
})
export class AccessAccountSectionComponent implements OnInit {

  constructor(
    private _dataStorageService: DataStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/access-account');
      ga('send', 'pageview');
      this._dataStorageService.removeCookie('dataID');
    }
  }

}
